import { GetVacationApi, AddVacationApi, GetVacationReasonApi } from '../api';
import { toast } from 'react-toastify';
import { GetToDay, StartCurrentMonth } from '../utils';

export const handelGetListVacationMethod = async (
    startDate: any,
    endDate: any,
    setDelayList: (list: any) => void,
    setDisplaySkeleton: (bol: boolean) => void,
    filterStatus: number,
    pagination: any,
    setPagination: (obj: any) => void,
) => {
    let start = StartCurrentMonth()
    let end = GetToDay()
    if (startDate && endDate) {
        start = startDate;
        end = endDate
    }
    try {
        setDisplaySkeleton(true)
        let res = await GetVacationApi(start, end, filterStatus, pagination?.current)
        setDisplaySkeleton(false)
        if (res.data.success) {
            setDelayList(res.data.data)
            setPagination({
                'current': res.data.data.current_page,
                'total': res.data.data.last_page,
            })
        }
        else {
            toast(res.data.message, { type: "error" })
            setDisplaySkeleton(false)
        }
    }
    catch (err: any) {
        setDisplaySkeleton(false)
    }
}


export const handelAddVacationMethod = async (
    formRef: any,
    dateForAdd: any,
    vacationTab: any,
    setDisplayBtn: (bol: boolean) => void,
    setVisibleAdd: (bol: boolean) => void,
    setDateForAdd: (obj: any) => void,
) => {
    if (vacationTab == 1 && !dateForAdd?.oneDate_jalali) return toast('انتخاب تاریخ مرخصی الزامیست', { type: "error" })
    if (vacationTab == 2 && !dateForAdd?.startDate_jalali) return toast('انتخاب تاریخ شروع مرخصی الزامیست', { type: "error" })
    if (vacationTab == 2 && !dateForAdd?.endDate_jalali) return toast('انتخاب تاریخ پایان مرخصی الزامیست', { type: "error" })
    let postData: any = {
        'date_from': vacationTab == 1 ? `${dateForAdd.oneDate_jalali} ${formRef.current['startTime'].value}:00` : `${dateForAdd?.startDate_jalali} 00:00:00`,
        'date_to': vacationTab == 1 ? `${dateForAdd.oneDate_jalali} ${formRef.current['endTime'].value}:00` : `${dateForAdd?.endDate_jalali} 00:00:00`,
        'description': formRef.current['description'].value,
        'type': vacationTab,
        'vacation_reason_id': +formRef.current['reason'].value,
    }
    try {
        setDisplayBtn(true)
        let res = await AddVacationApi(postData)
        setDisplayBtn(false)
        if (res.data.success) {
            setVisibleAdd(false)
            setDateForAdd(null)
            toast(res.data.message, { type: "success" })
            //@ts-ignore  
            document.getElementById('form-add-vacation')?.reset()
        }
        else {
            toast(res.data.message, { type: "error" })
            setDisplayBtn(false)
            setVisibleAdd(false)
        }
    }
    catch (err: any) {
        setDisplayBtn(false)
    }
}


export const handelGetVacationReasonList = async (
    setVacationReason: (list: any) => void,
) => {
    let res = await GetVacationReasonApi()
    if (res.data.success) {
        setVacationReason(res.data.data)
    }
}


